import React from "react";
import PropTypes from "prop-types";
import { CustomStackFullWidth } from "../../styled-components/CustomStyles.style";
import { Box, useTheme } from "@mui/material";
import { MainLayoutRoot } from "./LandingLayout";
import CustomLanguage from "../header/top-navbar/language/CustomLanguage";
import { useSelector } from "react-redux";

const AuthLayout = ({ children }) => {
  const theme = useTheme();
  const { language, countryCode } = useSelector((state) => state.configData);
  
  return (
    <MainLayoutRoot justifyContent="center" alignItems="center">
      <Box
        sx={{
          position: "absolute",
          top: "20px",
          right: "20px",
          zIndex: 1000,
        }}
      >
        <CustomLanguage
          language={language}
          countryCode={countryCode}
          noText={false}
        />
      </Box>
      <CustomStackFullWidth
        sx={{
          minHeight: "100vh",
          justifyContent: "center",
          alignItems: "center",
          padding: "2rem",
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: "500px",
            position: "relative",
          }}
        >
          {children}
        </Box>
      </CustomStackFullWidth>
    </MainLayoutRoot>
  );
};

AuthLayout.propTypes = {
  children: PropTypes.node,
};

export default AuthLayout;